<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CTableWrapper :items="getUsers" :itemsPerPage="itemsPerPage">
          <template #header>
            <CIcon name="cil-grid"/> Anzahl Dienstleister <strong>({{ getUsers.length }})</strong>
          </template>
        </CTableWrapper>
      </CCol>
    </CRow>
    <DeleteModal></DeleteModal>
  </div>
</template>

<script>

  import CTableWrapper from './../base/UserTable'

  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: "List",
    components: {
      CTableWrapper
    },
    data:()=> ({
      itemsPerPage: 25

    }),
    methods: {
      ...mapActions('user', [
        'loadUsers'
      ])
    },

    created() {
      this.loadUsers('service')
    },

    computed: {
      ...mapGetters('user', [
        'getUsers'
      ])
    }
  }
</script>

<style scoped>

</style>
